var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1315 0.706604C23.3201 0.706604 29.9577 7.34426 29.9577 15.5329C29.9577 23.7215 23.3201 30.3592 15.1315 30.3592C6.94283 30.3592 0.305176 23.7215 0.305176 15.5329C0.305176 7.34426 6.94283 0.706604 15.1315 0.706604ZM8.52681 22.4138H11.3664V13.2394H8.52681V22.4138ZM9.93299 12.0383C10.8608 12.0383 11.6125 11.2796 11.6125 10.3448C11.6125 9.4101 10.8608 8.65199 9.93299 8.65199C9.00519 8.65199 8.25403 9.4101 8.25403 10.3448C8.25403 11.2796 9.00519 12.0383 9.93299 12.0383ZM15.9058 17.5981C15.9058 16.3084 16.5 15.5393 17.6369 15.5393C18.6805 15.5393 19.1826 16.2771 19.1826 17.5981V22.4138H22.0089C22.0089 22.4138 22.0089 19.0622 22.0089 16.6049C22.0089 14.1476 20.616 12.9591 18.6707 12.9591C16.7247 12.9591 15.9058 14.4754 15.9058 14.4754V13.2394H13.182V22.4138H15.9058C15.9058 22.4138 15.9058 19.0113 15.9058 17.5981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.468d1bca32576dfebadfbbe3556ddf59.svg";
export { ForwardRef as ReactComponent };